var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewOrder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8215",
    "data-name": "Group 8215",
    transform: "translate(-220 -148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_255",
    "data-name": "Ellipse 255",
    transform: "translate(220 148)",
    fill: "#0069bf",
    stroke: "#0081ea",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7987",
    "data-name": "Group 7987",
    transform: "translate(-86.554 -145.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M317.4,299.691l4.359,1.918v5.838l-4.359,1.691-4.556-1.861.173-5.668Z",
    transform: "translate(-0.093 -0.136)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M23.244,2.139a.314.314,0,0,0-.195-.291L18.609.024a.315.315,0,0,0-.239,0L13.93,1.848a.314.314,0,0,0-.195.291V7.91a.314.314,0,0,0,.195.291l4.44,1.824a.313.313,0,0,0,.239,0L23.049,8.2a.314.314,0,0,0,.195-.291ZM18.49,3.649l-1.636-.672,3.536-1.542,1.746.717ZM14.364,2.634l1.412.58V4.85a.314.314,0,0,0,.629,0V3.472l1.771.728V9.265L14.364,7.7ZM18.49.654l1.09.448L16.044,2.645l-1.2-.493ZM18.8,4.2l3.812-1.566V7.7L18.8,9.265Z",
    transform: "translate(298.819 299.263)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewOrder);
export default __webpack_public_path__ + "static/media/New Order.2fd70236cb24cbfd877a9350b9829ab7.svg";
export { ForwardRef as ReactComponent };